export enum EnumPDVTpCaixa {
    WEBPDV = 0,
    SAURUSPDV = 1,
    ANDROID = 3
}